module.exports = __webpack_public_path__ + "3c73e30407eb64ed2965ec4eae148e92.png";